import React, { useState } from 'react';
import { FaExclamationCircle, FaPlus, FaFileAlt, FaCamera, FaCheck, FaTimes } from 'react-icons/fa';

const SellerClaims = () => {
    const [showNewClaim, setShowNewClaim] = useState(false);
    const [claimType, setClaimType] = useState('');
    const [claimDescription, setClaimDescription] = useState('');

    const claims = [
        {
            id: 'CLM001',
            type: 'Damaged in Transit',
            orderId: 'ORD145',
            product: 'Terracotta Vase',
            amount: 899,
            status: 'under_review',
            date: '2024-12-10',
            description: 'Product arrived broken at customer location'
        },
        {
            id: 'CLM002',
            type: 'Lost Shipment',
            orderId: 'ORD132',
            product: 'Handloom Stole',
            amount: 599,
            status: 'approved',
            date: '2024-12-08',
            description: 'Package not delivered, marked as lost'
        },
        {
            id: 'CLM003',
            type: 'Wrong Product Delivered',
            orderId: 'ORD128',
            product: 'Brass Lamp',
            amount: 1299,
            status: 'rejected',
            date: '2024-12-05',
            description: 'Customer received different product'
        },
    ];

    const getStatusBadge = (status) => {
        const styles = {
            under_review: 'bg-yellow-100 text-yellow-800',
            approved: 'bg-green-100 text-green-800',
            rejected: 'bg-red-100 text-red-800',
            pending: 'bg-blue-100 text-blue-800',
        };
        return styles[status] || 'bg-gray-100 text-gray-800';
    };

    const handleSubmitClaim = (e) => {
        e.preventDefault();
        // In production, submit to API
        alert('Claim submitted successfully!');
        setShowNewClaim(false);
        setClaimType('');
        setClaimDescription('');
    };

    return (
        <div className="p-6">
            <div className="mb-6 flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Claims Management</h1>
                    <p className="text-gray-600">File and track claims for damaged, lost, or incorrect shipments</p>
                </div>
                <button
                    onClick={() => setShowNewClaim(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                >
                    <FaPlus /> New Claim
                </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-yellow-500">
                    <p className="text-gray-500 text-sm">Under Review</p>
                    <p className="text-2xl font-bold text-gray-800">3</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-green-500">
                    <p className="text-gray-500 text-sm">Approved</p>
                    <p className="text-2xl font-bold text-gray-800">12</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-red-500">
                    <p className="text-gray-500 text-sm">Rejected</p>
                    <p className="text-2xl font-bold text-gray-800">2</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-blue-500">
                    <p className="text-gray-500 text-sm">Total Claimed</p>
                    <p className="text-2xl font-bold text-gray-800">₹15,450</p>
                </div>
            </div>

            {/* New Claim Modal */}
            {showNewClaim && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-lg">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">File New Claim</h2>
                        <form onSubmit={handleSubmitClaim} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Claim Type</label>
                                <select
                                    value={claimType}
                                    onChange={(e) => setClaimType(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                                    required
                                >
                                    <option value="">Select claim type</option>
                                    <option value="damaged">Damaged in Transit</option>
                                    <option value="lost">Lost Shipment</option>
                                    <option value="wrong">Wrong Product Delivered</option>
                                    <option value="short">Short Quantity</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Order ID</label>
                                <input
                                    type="text"
                                    placeholder="Enter order ID"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                                <textarea
                                    value={claimDescription}
                                    onChange={(e) => setClaimDescription(e.target.value)}
                                    rows={3}
                                    placeholder="Describe the issue in detail"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Upload Evidence</label>
                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                                    <FaCamera className="text-4xl text-gray-400 mx-auto mb-2" />
                                    <p className="text-sm text-gray-500">Click to upload photos or videos</p>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <button
                                    type="button"
                                    onClick={() => setShowNewClaim(false)}
                                    className="flex-1 py-2 border border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="flex-1 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
                                >
                                    Submit Claim
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Claims List */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <table className="w-full">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Claim ID</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Order</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {claims.map((claim) => (
                            <tr key={claim.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{claim.id}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-gray-600">{claim.type}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-blue-600">{claim.orderId}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-gray-600">{claim.product}</td>
                                <td className="px-6 py-4 whitespace-nowrap font-medium">₹{claim.amount}</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(claim.status)}`}>
                                        {claim.status.replace('_', ' ')}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-gray-500">{claim.date}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SellerClaims;
